import { connectAuthEmulator } from "firebase/auth";
import { connectFirestoreEmulator } from "firebase/firestore";
import { connectStorageEmulator } from "firebase/storage";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

let connected = false;

/**
 * Local-only: set REACT_APP_USE_FIREBASE_EMULATORS=true before `npm start`.
 */
export function connectFirebaseEmulatorsIfEnabled(app, { auth, db, storage }) {
  if (connected) return;
  if (process.env.REACT_APP_USE_FIREBASE_EMULATORS !== "true") return;

  const host = String(process.env.REACT_APP_FIREBASE_EMULATOR_HOST || "127.0.0.1").trim();
  const authPort = Number(process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_PORT || 9099);
  const firestorePort = Number(process.env.REACT_APP_FIREBASE_FIRESTORE_EMULATOR_PORT || 8080);
  const storagePort = Number(process.env.REACT_APP_FIREBASE_STORAGE_EMULATOR_PORT || 9199);
  const functionsPort = Number(process.env.REACT_APP_FIREBASE_FUNCTIONS_EMULATOR_PORT || 5001);

  connectAuthEmulator(auth, `http://${host}:${authPort}`, { disableWarnings: true });
  connectFirestoreEmulator(db, host, firestorePort);
  connectStorageEmulator(storage, host, storagePort);
  const functions = getFunctions(app, "us-central1");
  connectFunctionsEmulator(functions, host, functionsPort);
  connected = true;
}
